// Weight-unit display helpers.
// The dashboard stores and serves weight in kilograms (canonical unit, matching
// the agent workspace's USER.md / weight.json). The UI, however, displays pounds
// for the US-majority cohort — this is a display-only conversion. Keep storage in
// kg; convert to lb only at render time.

export const KG_TO_LB = 2.2046226218

export function kgToLb(kg: number): number {
  return kg * KG_TO_LB
}
